import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  ManagerOnboardingConfirmResult,
  ManagerOnboardingData,
  ManagerOnboardingDraft,
  ManagerOnboardingDraftListResponse,
  ManagerOnboardingMode,
} from './types/manager-onboarding';

const request = createAppRequest();

export const createManagerOnboardingDraft = (
  mode: ManagerOnboardingMode,
  options?: ApiRequestOptions,
) =>
  request<ManagerOnboardingDraft>('/bff/fams/manager-onboarding/drafts', {
    method: 'POST',
    data: { mode },
    ...(options || {}),
  });

export const listManagerOnboardingDrafts = (options?: ApiRequestOptions) =>
  request<ManagerOnboardingDraftListResponse>(
    '/bff/fams/manager-onboarding/drafts',
    {
      method: 'GET',
      ...(options || {}),
    },
  );

export const getManagerOnboardingDraft = (
  uuid: string,
  options?: ApiRequestOptions,
) =>
  request<ManagerOnboardingDraft>(`/bff/fams/manager-onboarding/drafts/${uuid}`, {
    method: 'GET',
    ...(options || {}),
  });

export const getManagerOnboardingDraftFile = (
  uuid: string,
  fileId: number,
  options?: ApiRequestOptions,
) =>
  request<Blob>(
    `/bff/fams/manager-onboarding/drafts/${uuid}/files/${fileId}`,
    { method: 'GET', responseType: 'blob', ...(options || {}) },
  );

export const uploadManagerOnboardingFiles = (
  uuid: string,
  files: File[],
  options?: ApiRequestOptions,
) => {
  const data = new FormData();
  files.forEach((file) => data.append('files', file));
  return request<ManagerOnboardingDraft>(
    `/bff/fams/manager-onboarding/drafts/${uuid}/files`,
    { method: 'POST', data, ...(options || {}) },
  );
};

export const parseManagerOnboardingDraft = (
  uuid: string,
  options?: ApiRequestOptions,
) =>
  request<ManagerOnboardingDraft>(
    `/bff/fams/manager-onboarding/drafts/${uuid}/parse`,
    { method: 'POST', ...(options || {}) },
  );

export const updateManagerOnboardingDraft = (
  uuid: string,
  data: ManagerOnboardingData,
  options?: ApiRequestOptions,
) =>
  request<ManagerOnboardingDraft>(`/bff/fams/manager-onboarding/drafts/${uuid}`, {
    method: 'PATCH',
    data: { data },
    ...(options || {}),
  });

export const confirmManagerOnboardingDraft = (
  uuid: string,
  data: ManagerOnboardingData,
  options?: ApiRequestOptions,
) =>
  request<ManagerOnboardingConfirmResult>(
    `/bff/fams/manager-onboarding/drafts/${uuid}/confirm`,
    { method: 'POST', data: { data }, ...(options || {}) },
  );

export const cancelManagerOnboardingDraft = (
  uuid: string,
  options?: ApiRequestOptions,
) =>
  request<{ success: boolean; uuid: string }>(
    `/bff/fams/manager-onboarding/drafts/${uuid}`,
    { method: 'DELETE', ...(options || {}) },
  );
